module.exports = __webpack_public_path__ + "img/productSatellite_10.713269d8.png";